import styled from 'styled-components';

import { GAME_TYPE } from '@shared/types/tournaments';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const ModalImg = styled.div<{ $backgroundImage: string }>`
	width: 100%;
	height: 200px;
	background-image: url('${({ $backgroundImage }) => $backgroundImage}');
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	border-radius: 12px 12px 0 0;
`;

export const ModalInfo = styled.div`
	padding: 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const ModalTitle = styled.h2`
	font-size: 24px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.title};
	margin: 0;
`;

export const ModalGame = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;
	flex-wrap: wrap;
`;

export const ModalGameItem = styled.div<{ $gameType: string }>`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 7px;
	border-radius: 100px;
  color: ${({ theme }) => theme.colors.text.alwaysWhite};
  font-size: 13px;
  font-weight: 400;
  background-color: ${({ theme, $gameType }) => {
    switch ($gameType) {
      case GAME_TYPE.CS2:
        return theme.colors.gameTag.cs2Bg;
      case GAME_TYPE.LOL:
        return theme.colors.gameTag.lolBg;
      case GAME_TYPE.DOTA2:
        return theme.colors.gameTag.dota2Bg;
      default:
        return theme.colors.background.secondary;
    }
  }};
`;

export const ModalCalendar = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text.body};
  font-weight: 400;

  svg {
    fill: ${({ theme }) => theme.colors.text.body};
  }
`;

export const ModalDescription = styled.div`
	font-size: 16px;
	line-height: 1.5;
	color: ${({ theme }) => theme.colors.text.body};
	font-weight: 400;
`;

export const ModalButtons = styled.div`
	justify-content: flex-end;
	display: flex;
	gap: 16px;
`;
